import { Component, OnInit, Output, EventEmitter, ElementRef, AfterViewChecked, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DataService } from '../../../services/data.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonJs } from '../../../common/common-js';
//  import { DragulaService } from 'ng2-dragula';
import swal from 'sweetalert2';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
//  import { NgProgressService } from 'ngx-progressbar';
import { AppConfigs } from '../../../common/app-configs';

import { VaniToasterService } from 'src/app/services/vani-toaster.service';

declare var $: any;
import * as _ from "lodash";
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'phases',
  templateUrl: './phases.component.html',
  styleUrls: ['./phases.component.css']
})
export class PhasesComponent implements OnInit {

  @ViewChild('hidePhase', { static: false }) hidePhase: ElementRef;
  @ViewChild('hideDept', { static: false }) hideDept: ElementRef;


  @Output() changePage = new EventEmitter();
  taskTypeInput: any;

  phaseForm!: NgForm;
  deptForm!: FormGroup;

  depatmentName = 'Depatments';
  depatmentNameSingular = 'Depatment';
  apiRoutePrefix = 'depatment';

  phaseName = 'Phases';
  phaseNameSingular = 'Phase';
  apiPhaseRoutePrefix = 'phase';

  apiTemplateRoutePrefix = 'deptTemplate';
  apiTasktypeRoutePrefix = 'tasktype';

  bsModalRef: BsModalRef;
  errors: { [index: string]: any } = {};
  edit_errors: { [index: string]: any } = {};
  SaveButtonTextDept: string = 'SAVE';
  SaveButtonTextPhase: string = 'SAVE';
  templateId: number = 0;

  templates: Templates;
  phase: Phase;
  department: Department;
  depatmentPhaseList: any;
  skeleton: boolean = true;

  displayDeptTask: boolean = false;
  deptTaskList = [
    { id: "1", name: "Task 1" },
    { id: "2", name: "Task 2" },
    { id: "3", name: "Task 3" },
  ];

  isDeleteMode: boolean = false;
  deleteModeData = [];

  moreToggleFlag: { [index: string]: boolean } = {};

  typeOptions = [
    { id: "pre", text: "Pre" },
    { id: "asset", text: "Asset" },
    { id: "shot", text: "Shot" },
    { id: "post", text: "Post" },
  ];

  assetOptions = this.appConfigs.assets_subtype;
  shotOptions = this.appConfigs.shot_subtype;

  settingsAll: any = JSON.parse(localStorage.getItem('settings'));
  loginRole = localStorage.getItem('role');

  dragulaOptions: any = {
    moves: function (el, container, handle) {
      return handle.className === 'dragula-handle material-icons';
    }
  }
  subs: Subscription[] = [];

  isPhaseSubmitted: boolean = false;
  isTaskTypeError: boolean = false;
  phaseSwitchLoading: string = '';

  @ViewChild('CloseOtherWindow', { static: false }) CloseOtherWindow: ElementRef;
  @HostListener('document:keydown.escape', ['$event'])
          handleEscapeKey(event: KeyboardEvent) {
            setTimeout(() => {
              this.bsModalRef.hide();
              this.CloseOtherWindow.nativeElement.click();
                    }, 2);
        }

  constructor(
    private dragulaService: DragulaService,
    private modalService: BsModalService,
    private fb: FormBuilder,
    public commonJs: CommonJs,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    public appConfigs: AppConfigs,
    private dataService: DataService,
    private toastrService: VaniToasterService) {


    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['template_id'] != undefined) {
        this.templateId = params['template_id'];
      }
    });

    this.dragulaService.createGroup('another-bag', {
      moves: (el, container, handle) => handle.className === ''
    });

  }

  ngOnInit() {
    this.subs.push(
      this.dragulaService.drop().subscribe(({ name, el, source, target, sibling }) => {
        // Find the source department and its phase
        const sourceDepartmentId = +(<HTMLElement>el).getAttribute('data-id');
        const sourcePhase = this.depatmentPhaseList.find(phase => phase.department.some(dept => dept.id === sourceDepartmentId));

        // Find the target department and its phase
        const targetDepartmentId = +(<HTMLElement>sibling).getAttribute('data-id');
        const targetPhase = this.depatmentPhaseList.find(phase => phase.department.some(dept => dept.id === targetDepartmentId));

        if (sourcePhase && targetPhase) {
          // Find the source and target department indices
          const sourceIndex = sourcePhase.department.findIndex(dept => dept.id === sourceDepartmentId);
          const targetIndex = targetPhase.department.findIndex(dept => dept.id === targetDepartmentId);

          // Move the department from the source to the target phase
          const movedDepartment = sourcePhase.department.splice(sourceIndex, 1)[0];
          targetPhase.department.splice(targetIndex, 0, movedDepartment);

          this.dataService.getListData(this.apiRoutePrefix + 'Order', { 'depatmentPhaseList': this.depatmentPhaseList })
            .subscribe((success:any) => {
              // this.toastrService.notify('success', '', success.msg ? success.msg : 'success');
            }, (rejected) => {
              this.toastrService.notify('error', '', rejected.msg ? rejected.msg : 'Something went wrong');
              console.log(rejected)
            });
        }
      })
    );


    //const elem = document.querySelectorAll('.scrollLast');
    //elem.scrollIntoView();
    this.templates = {
      name: '',
      is_default: 1,
      status: 1
    }

    this.phase = {
      name: '',
      type: '',
      subtype: '',
      dept_template_id: this.templateId,
      is_production: 0
    }

    this.department = {
      name: '',
      phase_id: 0,
      is_default: 0,
      dept_template_id: this.templateId
    }

    // Initialize the reactive form
    this.buildDeptForm();

    this.getDepatmentPhaseList();

    // this.dataService.getListData('listItemList/ac_assets_subtype', '')
    //   .subscribe((success:any) => {
    //     this.assetOptions = success.data;
    //   }, (rejected) => {

    //   });

    // this.dataService.getListData('listItemList/ac_shots_subtype', '')
    //   .subscribe((success:any) => {
    //     this.shotOptions = success.data;
    //   }, (rejected) => {

    //   });

    this.titleService.setTitle(this.phaseName);
  }

  // ngAfterViewChecked(){
  // }



  ngOnDestroy() {
    this.dragulaService.destroy('another-bag');
  }

  deleteDepartment(name, id) {
    if (name && id) {
      this.dataService.deleteData(this.apiRoutePrefix + 'Destroy', { id })
        .subscribe((success:any) => {

          if (success.status == "success") {
            this.getDepatmentPhaseList();
          }

          this.toastrService.notify(success.status, '', success.message);

        }, (rejected) => {

        });
    } else {
      //console.log('cancelled');
    }
    this.bsModalRef.hide();
    this.isDeleteMode = false;
  }

  deletePhase(name, id) {
    let that = this;
    swal.fire({
      title: "Delete Phase",
      html: "Are you sure you want to delete <span style='font-weight:600'>" + name + "</span> phase?",
      // icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        that.dataService.deleteData(that.apiPhaseRoutePrefix + 'Destroy', { id })
          .subscribe((success:any) => {
            if (success.status == 'error') {
              that.toastrService.notify('error', '', success.message);
            } else {
              that.getDepatmentPhaseList();
            }
          }, (error) => {
            //console.log(error);
          });
      } else {
        //console.log('cancelled');
      }
    }
    )
  }

  routerLink(path) {
    this.router.navigate(['/' +  '/phases/dependency/' + path]);
  }

  onShownPhase(phaseData) {
    /*this.phase = {
      name : phase.name,
      type : phase.type
    }*/
    if (phaseData != undefined && phaseData != '') {
      this.phase['id'] = phaseData.id;
      this.phase['name'] = phaseData.name;
      this.phase['type'] = { id: phaseData.type, text: phaseData.type };
      this.phase['subtype'] = { id: phaseData.subtype, name: phaseData.subtype };
      this.phase['is_default'] = phaseData.is_default;
      this.phase['is_production'] = phaseData.is_production;
    } else {
      this.phase['id'] = '';
      this.phase['name'] = '';
      this.phase['type'] = '';
      this.phase['subtype'] = '';
      this.phase['is_default'] = 0;
      this.phase['is_production'] = 0;
    }
    this.errors = {};
  }

  onSubmit(form: NgForm) {
    this.isPhaseSubmitted = true;
    this.SaveButtonTextPhase = 'SAVING';

    if (form.value.subtype) {
      form.value.subtype = this.phase.subtype.id;
    }

    if (form.value.type) {
      form.value.type = this.phase.type.id;
      if (this.phase['type']['id'] == 'shot') {
        form.value.subtype = 'Shot';
      }
    }

    if (this.phase['type']['id'] == 'shot' || this.phase['type']['id'] == 'asset') {
      form.value.is_production = 1;
    }

    if (this.phase['id'] != '') {

      this.dataService.updateData(this.apiPhaseRoutePrefix + '/' + this.phase['id'], form.value)
        .subscribe((success:any) => {
          // Save effect within button
          setTimeout(() => {
            this.SaveButtonTextPhase = 'SAVE';
            this.getDepatmentPhaseList();
          }, 2);

          setTimeout(() => {
            this.isPhaseSubmitted = false;
          }, 2000);

        }, (error) => {
          var error = error();
          if (error.error) {
            var err = error.error;
            this.errors = err.error;
            this.toastrService.notify('error', '', err.message);
          }
          this.SaveButtonTextPhase = 'SAVE';
          this.isPhaseSubmitted = false;
        });

    } else {

      this.dataService.storeData(this.apiPhaseRoutePrefix, form.value)
        .subscribe((success:any) => {
          // Save effect within button
          setTimeout(() => {
            this.SaveButtonTextPhase = 'SAVE';
            this.getDepatmentPhaseList();
            this.hidePhase.nativeElement.click();
          }, 2);

          setTimeout(() => {
            this.isPhaseSubmitted = false;
          }, 2000);

        }, (error) => {
          var error = error();
          //this.alertMessage = 'Something went wrong, Please try again!';
          if (error.error) {
            var err = error.error;
            this.errors = err.error;
            this.toastrService.notify('error', '', err.message);

          }
          this.SaveButtonTextPhase = 'SAVE';
          this.isPhaseSubmitted = false;
        });
    }
  }

  onShownDept(phase_id, depart_id, depart_name, is_default = 0) {
    if (depart_id != undefined && depart_id != '') {
      this.department['id'] = depart_id;
      this.department['name'] = depart_name;
      this.getTasktypeList(depart_id);

      // Update the form values
      this.deptForm.patchValue({
        name: depart_name,
        phase_id: phase_id,
        is_default: is_default,
        dept_template_id: this.templateId
      });
    } else {
      this.department['id'] = '';
      this.department['name'] = '';

      // Reset the form for new department
      this.deptForm.patchValue({
        name: '',
        phase_id: phase_id,
        is_default: is_default,
        dept_template_id: this.templateId
      });
    }
    this.department.phase_id = phase_id;
    this.department.is_default = is_default;

    this.errors = {};
  }

  onSubmitDept() {
    // Trim whitespace before submission
    this.trimWhitespace();

    // Stop here if form is invalid
    //console.log((this.deptForm.invalid));
    if (this.deptForm.invalid) {
      return;
    }

    this.SaveButtonTextDept = 'SAVING';

    // Get form values
    const formValues = this.deptForm.value;

    // Update department object with form values
    this.department.name = formValues.name;
    this.department.phase_id = formValues.phase_id;
    this.department.is_default = formValues.is_default;
    this.department.dept_template_id = formValues.dept_template_id;

    if (this.department['id'] != '') {
      this.dataService.updateData(this.apiRoutePrefix + '/' + this.department['id'], this.department)
        .subscribe((success:any) => {
          // Save effect within button
          setTimeout(() => {
            this.SaveButtonTextDept = 'SAVE';
            this.getDepatmentPhaseList();
          }, 2);

        }, (error) => {
          var error = error();
          if (error.error) {
            var err = error.error;
            this.errors = err.error;
            this.toastrService.notify('error', '', err.message);
            // Mark form controls as touched to show validation errors
            // Object.keys(this.deptForm.controls).forEach(key => {
            //   this.deptForm.get(key)?.markAsTouched();
            // });
          }
          this.SaveButtonTextDept = 'SAVE';
        });

    } else {
      this.dataService.storeData(this.apiRoutePrefix, this.department)
        .subscribe((success:any) => {
          // Save effect within button
          setTimeout(() => {
            this.SaveButtonTextDept = 'SAVE';
            this.getDepatmentPhaseList();
          }, 2);
          this.toastrService.notify('success', '', success.message ? success.message : 'success');

        }, (error) => {
          var error = error();
          if (error.error) {
            var err = error.error;
            this.errors = err.error;
            this.toastrService.notify(err.status, '', err.message);

            // Mark form controls as touched to show validation errors
            // Object.keys(this.deptForm.controls).forEach(key => {
            //   this.deptForm.get(key)?.markAsTouched();
            // });
          }
          this.SaveButtonTextDept = 'SAVE';
        });
    }
    this.bsModalRef.hide();
  }

  // Helper method to check if a form control is invalid and touched or dirty
  isInvalid(controlName: string): boolean {
    const control = this.deptForm.get(controlName);
    return control ? control.invalid && (control.touched || control.dirty) : false;
  }

  // Helper method to check if a form control has a specific error
  hasError(controlName: string, errorName: string): boolean {
    const control = this.deptForm.get(controlName);
    return control ? control.hasError(errorName) && (control.touched || control.dirty) : false;
  }

  // Trim whitespace from the beginning and end of the name input
  trimWhitespace() {
    const nameControl = this.deptForm.get('name');
    if (nameControl && nameControl.value) {
      const trimmedValue = nameControl.value.trim();
      if (trimmedValue !== nameControl.value) {
        nameControl.setValue(trimmedValue);
      }
    }
  }

  getDepatmentPhaseList() {
    //$('.collapse-btn').html('More');
    this.dataService.getListData(this.apiRoutePrefix + 'List', { 'template_id': this.templateId })
      .subscribe((success:any) => {
        this.depatmentPhaseList = success.data;
        this.skeleton = false;
        /*let that = this;
        _.forEach(this.depatmentPhaseList, function(item) {
            if ( item['type'] == 'asset' ) {

                const index = that.assetOptions.findIndex((col) => {
                  return col.id == item['subtype'];
                });
                if (index !== -1) {
                  that.assetOptions.splice(index, 1);
                }
            } else if (item['type'] == 'shot') {

                const index = that.shotOptions.findIndex((col) => {
                  return col.id == item['subtype'];
                });
                if (index !== -1) {
                  that.shotOptions.splice(index, 1);
                }
            }
        });*/
        this.moreToggleFlag = {};
        //assetOptions

      }, (rejected) => {
        this.skeleton = false;
      });
  }

  onChange(flag) {
    var tempCheck = [];
    if (flag) {
      this.phase['is_production'] = 1;
    } else {
      this.phase['is_production'] = 0;
      this.phase['type'] = '';
      this.phase['subtype'] = '';
    }
  }

  moreToggle(pi) {
    this.moreToggleFlag[pi] = !this.moreToggleFlag[pi];
    if (this.moreToggleFlag[pi]) {
      $('.other-dept.other-dept-' + pi).show();
    } else {
      $('.other-dept.other-dept-' + pi).hide();
    }
  }

  cellClick(id): any { //onCellClick
    if (id != undefined) {
      $('.cursor-pointer').removeClass('active');
      $('.' + id + '-td').addClass('active');
      $('.' + id + '-input input').focus();
    }
  }

  cellUpdate(data: any = {}, isNew = false, depId = 0, dept): any {
    // console.log(data.target.value.toLowerCase(), dept['name'].toLowerCase());
    //this.isTaskTypeError = false;
    this.errors = {};
    this.edit_errors = {};

    if(data.target && data.target.value){
      if (data.target.value.toLowerCase() == dept['name'].toLowerCase()) {
        this.toastrService.notify('error', '', "Sub-department name can not be same as parent department!");
        return false;
      }
    } else {
      if(data.name){
        if (data.name.toLowerCase() == dept['name'].toLowerCase()) {
          this.toastrService.notify('error', '', "Sub-department name can not be same as parent department!");
          return false;
        }
      }
    }

    if (isNew) {
      console.log(data);
      if (data.target && data.target.value == "") {
        //this.edit_errors.name = "Required";
        return false;
      }
      //this.department['tasks'].push({id: (Object.keys(this.department['tasks']).length + 1), name: data.target.value});
      this.dataService.storeData(this.apiTasktypeRoutePrefix, { department_id: depId, name: data.target.value })
        .subscribe((success:any) => {
          setTimeout(() => {
            this.getTasktypeList(depId);

          }, 2);

        }, (error) => {
          var error = error();
          //this.alertMessage = 'Something went wrong, Please try again!';
          if (error.error) {
            var err = error.error;
            this.errors = err.error;
            this.toastrService.notify('error', '', err.message);

            //this.isTaskTypeError = true;
          }
        });

    } else {
      if (data.name == "") {
        //this.edit_errors.name = "Required";
        return false;
      }
      this.dataService.updateData(this.apiTasktypeRoutePrefix + '/' + data.id, data)
        .subscribe((success:any) => {

          $('.' + data.id + '-td').removeClass('active');
          setTimeout(() => {
            this.getTasktypeList(depId);
          }, 2);

        }, (error) => {
          var error = error();
          if (error.error) {
            var err = error.error;
            this.edit_errors[data.id] = err.error;
            this.toastrService.notify('error', '', err.message);

            this.isTaskTypeError = true;
          }
        });
    }
    this.getDepatmentPhaseList();
  }

  deleteTask(id, name, depId) {
    this.dataService.deleteData(this.apiTasktypeRoutePrefix + 'Destroy', { id })
      .subscribe((success:any) => {
        this.isDeleteMode = false;
        if (success.status == 'error') {
          this.toastrService.notify('error', '', success.message);
        } else {
          this.getTasktypeList(depId);
        }
      }, (rejected) => {

      });
  }

  getTasktypeList(depId) {
    this.dataService.getListData(this.apiTasktypeRoutePrefix + 'List', { 'department_id': depId })
      .subscribe((success:any) => {
        this.department['tasks'] = success.data;
        if (Object.keys(this.department['tasks']).length > 0) {
          //$('.'+depId+'-tasktypeCount').show();
          //$('.'+depId+'-tasktypeCount').html('('+Object.keys(this.department['tasks']).length+')');
        } else {
          //$('.'+depId+'-tasktypeCount').hide();
        }
      }, (rejected) => {

      });
  }

  deleteModeTogg(task, taskIndex) {
    // this.isDeleteMode = true;
    this.deleteModeData = task;
    // this.department['tasks'].splice(taskIndex,1);
    // console.log(this.deleteModeData['tasktype'].total_tasktype);
    this.deleteTask(this.deleteModeData['id'], this.deleteModeData['name'], this.department['id']);
    this.getDepatmentPhaseList();

  }

  search(query, column) {

    if (column == 'type') {
      this.typeOptions = this.typeOptions.map(o => {
        return o;
      });

    } else if (column == 'asset-subtype') {
      this.assetOptions = this.assetOptions.map(o => {
        return o;
      });

    } else if (column == 'shot-subtype') {
      this.shotOptions = this.shotOptions.map(o => {
        return o;
      });

    }
  }

  // To open modal for edit department detail
  openDepartmentModal(template: TemplateRef<any>, actionType, deleteData?) {
    console.log(actionType);
    switch (actionType) {
      case 'editDept':
        this.displayDeptTask = this.isDeleteMode = false;
        break;
      case 'editSubtask':
        this.displayDeptTask = true;
        this.isDeleteMode = false;
        break;
      case 'deleteDept':
        this.displayDeptTask = false;
        this.deleteModeData = deleteData;
        this.isDeleteMode = true;
        break;
      default:
        this.displayDeptTask = false;
        this.isDeleteMode = false;
        break;
    }
    // this.isDeleteMode = false;
    // this.displayDeptTask = actionType=='editDept'?false:true;
    this.bsModalRef = this.modalService.show(template);
  }

  // Get Unassigned tasks
  onButtonToggled(value: any, phaseValue:any) {

    this.phaseSwitchLoading = phaseValue['name'];

    //console.log(phaseValue);
    // console.log(phaseValue['isHidden']);
    this.dataService.getListData(this.apiRoutePrefix + 'Order', { 'depatmentPhaseList': this.depatmentPhaseList })
    .subscribe((success:any) => {

      if(success.status=='denied'){

        this.depatmentPhaseList.map((phase)=>{
          if(phase.name == phaseValue.name){
            // phase.isHidden = 0;
            phase.isHidden = !phase.isHidden;
          }
         });
         this.toastrService.notify('error', '', success.message ? success.message : 'error');
      }else{
        // console.log(this.depatmentPhaseList)
        this.dataService.pagePreferancePost({
          departmentPhaseList: this.depatmentPhaseList.map(obj => ({ id: obj.id, name: obj.name, isHidden: obj.isHidden, type: obj.type , subtype: obj.subtype}))
        }, 'phasesExistence');

        let phasesExist = this.depatmentPhaseList.reduce((obj, item) => {
          if (item.name!="SUPPORT" && (item.isHidden == 0 || item.isHidden == false)) {

            if(item.subtype==null || item.subtype==''){
              obj[item.type.toLowerCase()] = item.isHidden ? 0 : 1;
            }else{
              obj[item.subtype.toLowerCase()] = item.isHidden ? 0 : 1;
            }
          }
          return obj;
        }, {});

        // console.log(this.commonJs.phasesExist);console.log(phasesExist)
        for(let ps of ['pre', 'character', 'set', 'prop', 'shot', 'post']){
          if(!phasesExist.hasOwnProperty(ps)){
            phasesExist[ps] = 0;
          }
        }

        // console.log(phasesExist);
        localStorage.setItem('phasesExist',JSON.stringify(phasesExist));
        // localStorage.setItem('phasesExist',JSON.stringify(this.commonJs.phasesExist));

        this.toastrService.notify('success', '', success.message ? success.message : 'success');

      }
      this.phaseSwitchLoading = '';
    }, (rejected) => {
      this.phaseSwitchLoading = '';
      console.log(rejected)
    });
  }

  // Build the reactive form
  buildDeptForm() {
    this.deptForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern(/^(?!\s)(?!.*\s$).*$/) // Allow spaces between words but not at start/end
      ]],
      phase_id: [0],
      is_default: [0],
      dept_template_id: [this.templateId]
    });
  }

}

interface Templates {
  name: string,
  is_default: number,
  status: number
}

interface Phase {
  name: string,
  type: any,
  subtype: any,
  dept_template_id: number,
  is_production: number
}

interface Department {
  name: string,
  phase_id: number,
  is_default: number,
  dept_template_id: number
}
